import Table from "./Table";
import styled from "styled-components";
import colours from "../../../views/theme/base/colours";
import Pill from "../../../views/components/Pill";

const StyledTable = styled(Table)`
  * {
    vertical-align: middle;
  }

  table {
    border-collapse: separate;
    border-spacing: 0 1rem;
    margin-top: 3rem;
  }

  td {
    padding: 0.5rem;
    font-size: 1.4rem;
  }

  th,
  tr {
    margin-bottom: 1rem;
    background: white;
    color: ${colours.PRIMARY.base};
    text-align: center;
    padding: 0.5rem;
  }

  tr th {
    background: ${colours.PRIMARY.shades[5]};
    font-weight: 600;
  }
   
  ${(props) =>
    (props.widths || ["5%", "8rem", "13rem", "20rem", "13rem", "22rem", "20rem", "15rem", "5%"]).map(
      (width, index) => `
        tr td:nth-child(${index + 1}) {
          width: ${width};
        }
      `
    )}

  .reg-number {
    width: 10;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .magnifying-glass {
    cursor: pointer;
  }

  .name-tag {
    font-weight: bold;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: default;
    &__remove {
      padding-left: 6px;
      cursor: pointer;
      transition: opacity 0.2s ease-in-out;
      :hover {
        opacity: 0.5;
      }
    }

    ${Pill} {
      color: ${colours.WHITE};
      background-color: ${colours.ORANGE.base};
      cursor: pointer;
    }
  }

  .response-due__missedsla {
    color: ${colours.RED.base};
  }

  .response-due__withinoneday {
    color: ${colours.ORANGE.base};
  }

  .response-due__ok {
    color: ${colours.PRIMARY.base};
  }
`;

export default StyledTable;
